import { ChevronDown, ChevronUp, Package } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { SlotBadge } from '@frontend/slot/badge';
import { UserBadge } from '@frontend/user/badge';
import { LuCheck } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useConfirmPickUp from './confirm-pick-up.controller';

const ID = 'confirm-pick-up';

const ConfirmPickUp = () => {
    const viewProps = useConfirmPickUp();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.PICK_UP }}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled,
                submitLabel: (
                    <FormattedMessage
                        id='finish-pick-up'
                        defaultMessage='Finish pick-up'
                    />
                )
            }}>
            <div className='flex w-full flex-col items-start justify-start gap-3'>
                <div className='flex w-full flex-col items-start justify-start gap-3'>
                    <div className='text-foreground-default justify-start text-base font-medium'>{CommonMessage.BUTTONS.CONFIRMATION}</div>
                    <div className='flex w-full flex-col items-start justify-start gap-3'>
                        {viewProps.transaction && (
                            <div className='bg-background-surface inline-flex w-full flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4'>
                                <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                    <div className='text-brand-muted justify-start text-base font-medium'>
                                        {CommonMessage.OBJECTS.TRANSACTION.PURCHASE_ORDER}
                                    </div>
                                    <div className='text-foreground-default justify-start text-base font-medium'>{viewProps.transaction.purchase_order}</div>
                                </div>
                                <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                    <div className='text-brand-muted justify-start text-base font-medium'>
                                        {CommonMessage.OBJECTS.TRANSACTION.TRACKING_NUMBER}
                                    </div>
                                    <div className='text-foreground-default justify-start text-base font-medium'>{viewProps.transaction.tracking_number}</div>
                                </div>
                                <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                    <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.SUPPLIER.DEFAULT}</div>
                                    {viewProps.transaction.supplier && (
                                        <div className='text-foreground-default justify-start text-base font-medium'>
                                            {viewProps.transaction.supplier ?? '/'}
                                        </div>
                                    )}
                                </div>
                                {viewProps.receivers && viewProps.receivers.length > 0 && (
                                    <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                        <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.TRANSACTION.RECEIVER}</div>
                                        <UserBadge
                                            id={viewProps.receivers[0].user_id || undefined}
                                            className='text-foreground-default justify-start text-base font-medium'
                                        />
                                    </div>
                                )}
                                <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                    <div className='text-brand-muted justify-start text-base font-medium'>
                                        <FormattedMessage
                                            id='pick-up-by'
                                            defaultMessage='Pick-up by'
                                        />
                                    </div>
                                    <div className='text-foreground-default justify-start text-base font-medium'>
                                        <UserBadge
                                            className='text-foreground-default justify-start text-base font-medium'
                                            id={viewProps.pickedUpBy || undefined}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {viewProps.collis &&
                            viewProps.collis.map((colli, index) => (
                                <div
                                    key={index}
                                    className='bg-background-surface inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4'>
                                    <div className='inline-flex items-center justify-between self-stretch'>
                                        <div className='flex items-center justify-start gap-4'>
                                            <div className='outline-border-default relative flex size-12 items-center justify-center rounded-full outline-2'>
                                                <LuCheck className='bg-status-success text-background-surface absolute top-0 right-0 size-4 rounded-full p-0.5' />
                                                <Package className='size-1/2' />
                                            </div>

                                            <div className='inline-flex flex-col items-start justify-center gap-1'>
                                                <div className='text-foreground-default justify-start text-base font-semibold'>{colli.label}</div>
                                                <div className='text-brand-muted justify-start text-base font-medium'>
                                                    <span className='text-brand-muted justify-start text-base font-medium'>
                                                        {CommonMessage.OBJECTS.SLOT.DEFAULT}{' '}
                                                        <SlotBadge
                                                            id={colli.current_slot_id || undefined}
                                                            className='ms-0 ps-0'
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        {viewProps.transaction?.shipping_notes && (
                            <>
                                <div className='text-foreground-default justify-start text-base font-medium'>
                                    {CommonMessage.OBJECTS.TRANSACTION.SHIPPING_NOTES}
                                </div>
                                <div
                                    data-state='Open'
                                    className='bg-background-surface inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4'>
                                    <div className='inline-flex items-center justify-between self-stretch'>
                                        <div className='flex items-center justify-start gap-4'>{viewProps.transaction.shipping_notes}</div>
                                    </div>
                                </div>
                            </>
                        )}

                        {viewProps.transaction?.comments && (
                            <>
                                <div className='inline-flex items-center justify-between self-stretch'>
                                    <div className='text-foreground-default justify-start text-center text-base font-medium'>
                                        {CommonMessage.OBJECTS.TRANSACTION.COMMENTS}
                                    </div>
                                    <div
                                        className='inline-flex h-5 w-5 flex-col items-center justify-center gap-2.5'
                                        onClick={() => viewProps.setCommentsVisible(!viewProps.commentsVisible)}>
                                        {viewProps.commentsVisible ? <ChevronUp /> : <ChevronDown />}
                                    </div>
                                </div>
                                {viewProps.commentsVisible && (
                                    <div
                                        data-state='Open'
                                        className='bg-background-surface inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4'>
                                        <div className='inline-flex items-center justify-between self-stretch'>
                                            <div className='flex items-center justify-start gap-4'>{viewProps.transaction.comments}</div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default ConfirmPickUp;
